import styled from "@emotion/styled";
import type { FC } from "react";
import refillHeroImg from "src/ui/assets/images/refill-hero.jpg";
import CountdownRing, { type CountdownTone } from "./CountdownRing";

/** Hub hero: photo + dark gradient overlay, with the countdown pill directly above the
 * title at the bottom. The requirements block below overlaps up into the reserved
 * bottom padding (see PrepareRefillDialogV2). Figma: Medication Experience – v1
 * (node 5805:93910): pt-160 pb-88, countdown gap-16 above the 40px serif title.
 * Same hero image for both cohorts; the title differs and the countdown ring is
 * concierge-only (hidden for the non-concierge "secure your coverage" variant, which
 * has no refill window/countdown). */
const Hero = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 1rem;
  min-height: 300px;
  padding: 1.5rem 1.5rem 88px;
  color: var(--color-white);
  background-image:
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 33%,
      rgba(0, 0, 0, 0.64) 77%,
      rgba(0, 0, 0, 0.72) 100%
    ),
    linear-gradient(rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12)),
    url(${refillHeroImg});
  background-size: cover;
  background-position: center;
`;

const Title = styled.h2`
  margin: 0;
  font-family: "STK Bureau Serif", serif;
  font-weight: 300;
  font-size: 2.5rem;
  line-height: 1.1;
  letter-spacing: -0.5px;
`;

const RefillHubHeader: FC<{
  title: string;
  days: number;
  fraction: number;
  tone: CountdownTone;
  overdue?: boolean;
  showCountdown: boolean;
}> = ({ title, days, fraction, tone, overdue, showCountdown }) => (
  <Hero>
    {showCountdown && (
      <CountdownRing
        days={days}
        fraction={fraction}
        tone={tone}
        overdue={overdue}
      />
    )}
    <Title>{title}</Title>
  </Hero>
);

export default RefillHubHeader;
